<template>
  <div class="app-container">
    <header-site/>
    <main style="flex: 1 0 auto;">
      <router-view/>
    </main>
    <footer-site/>
  </div>
</template>

<script>
import HeaderSite from '@/components/HeaderSite.vue'
import FooterSite from '@/components/FooterSite.vue'

import {mapActions/*, mapGetters, mapState*/} from "vuex";

export default{
  components:{
    HeaderSite,
    FooterSite,
  }, 
  computed: {
   //...mapState(['imt', 'ipto']),
   //...mapGetters(['iptoGroups', 'imtGroups']),
  },

  async mounted() {
    await this.onLoad()
  },

  methods:{
    ...mapActions(['onLoad']),
  },
  
}
</script>
<style lang="css" scoped>
.app-container { /* замените класс на ваш корневой класс приложения */
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Растягивает страницу на всю высоту экрана */
  box-sizing: border-box;
}
</style>